<input #fileInput type="file" class="d-none" accept=".csv,.xlsx,.xls" (change)="onFileSelected($event)" />
<div class="d-flex flex-wrap align-items-center gap-3 mb-3">
  <button class="btn btn-outline-secondary btn-h42 ms-auto" (click)="onExportClick()">
    <i class="bi bi-download me-1"></i>
    Export
  </button>
  <button class="btn btn-primary btn-h42" (click)="onImportClick()">
    <i class="bi bi-{{ lotRelationships().length > 0 ? 'arrow-clockwise' : 'upload' }} me-1"></i>
    {{ lotRelationships().length > 0 ? 'Re import' : 'Import' }}
  </button>
  <!--   
  <a
    href="https://filemanager-bucket-public.s3.ca-central-1.amazonaws.com/shared/Plainview+Lot+Relationships.xlsx"
    download
    class="btn btn-h42 btn-outline-success"
  >
    <i class="bi bi-file-earmark-spreadsheet fs-20"></i>
    Sample Filegdfgdfgdf
  </a> -->
</div>
@if (importErrors().length > 0) {
  <div class="alert alert-danger mb-3 p-3">
    <div class="d-flex align-items-center gap-2 mb-2">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <strong
        >Import failed — {{ importErrors().length }} error{{ importErrors().length === 1 ? '' : 's' }} found</strong
      >
    </div>
    <ul class="mb-0 ps-3">
      @for (error of importErrors(); track $index) {
        <li class="fs-14">{{ error }}</li>
      }
    </ul>
  </div>
}
<div class="flex-fill overflow-hidden">
  <div class="d-flex flex-column gap-3 h-100">
    @if (lotRelationships().length === 0) {
      <!-- Empty State -->
      <div class="d-flex align-items-center justify-content-center h-100 bg-gray-100 rounded-4">
        <div class="text-center text-muted">
          <p class="mb-3 fs-16">No relationship exists yet, start by uploading.</p>
        </div>
      </div>
    } @else {
      <div class="table-outer table-theme flex-fill">
        <div class="table-responsive h-100">
          <p-table
            [className]="'table-prime'"
            [value]="lotRelationships()"
            dataKey="id"
            [scrollable]="true"
            [rowHover]="true"
            styleClass="p-datatable-striped"
          >
            <ng-template #header>
              <tr>
                <th>Lot</th>
                <th>Beside Lots</th>
                <th>In front Lots</th>
                <th>Diagonal Lots</th>
                <th>Corner Lot</th>
              </tr>
            </ng-template>
            <ng-template #body let-relationship>
              <tr>
                <td>{{ relationship.lotNo }}</td>
                <td>{{ getLotNumbers(relationship.besideLots) }}</td>
                <td>{{ getLotNumbers(relationship.inFrontLots) }}</td>
                <td>{{ getLotNumbers(relationship.diagonalLots) }}</td>
                <td>{{ relationship.isCornerLot ? 'YES' : 'NO' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    }
  </div>
</div>
